__turbopack_context__.v({
  "container": "r2NyFG_container",
  "pin": "r2NyFG_pin",
  "pinContainer": "r2NyFG_pinContainer",
  "shimmer": "r2NyFG_shimmer",
  "text-bar-sweep": "r2NyFG_text-bar-sweep",
});
